import React from 'react';
// @ts-ignore
import styles from './DENTModalOverviewPeriodontalSelectMapBox.module.scss';
import DENTModalOverviewPeriodontalSelectMapBoxItem from './DENTModalOverviewPeriodontalSelectMapBoxItem';
import useTranslation from '../../../../Hooks/useTranslation';
import { useDENTContext } from '../../Services/DENTContext';
import { OverviewMode } from '../../Enums/OverviewMode.enum';

interface Props {
	title: string;
	values: Record<string, number>;
	hiddenValues?: number[];
	selectedValue?: number;
	setValue: (value: number) => void;
	onChangeValues?: () => void;
}

const DENTModalOverviewPeriodontalSelectMapBox = ({
	title,
	values,
	hiddenValues,
	selectedValue,
	setValue,
	onChangeValues,
}: Props) => {
	const { overviewMode } = useDENTContext();
	const { t } = useTranslation();

	const items = [
		...Object.entries(values).map(([key, value]) => ({
			key,
			value: key,
			isSelected: selectedValue === value,
			isHidden: hiddenValues ? hiddenValues.includes(value) : false,
			onClick: () => setValue(value),
		})),
		...Array.from({ length: 14 - Object.keys(values).length }).map((_, i) => ({
			key: `empty-${i}`,
			value: '',
			isSelected: false,
			isHidden: true,
			onClick: () => {},
		})),
		...(onChangeValues
			? [
					{
						key: 'toggle',
						value: '+/-',
						isSelected: false,
						isHidden: false,
						onClick: onChangeValues,
					},
			  ]
			: []),
	];

	return (
		<div
			className={
				overviewMode === OverviewMode.PERIODONTAL
					? styles.quickAdjustmentWrapper
					: styles.wrapper
			}>
			<h5>{t(title)}</h5>
			<div className={styles.options}>
				{items.map(item => (
					<DENTModalOverviewPeriodontalSelectMapBoxItem
						key={item.key}
						value={item.value}
						isSelected={item.isSelected}
						isHidden={item.isHidden}
						onClick={item.onClick}
					/>
				))}
			</div>
		</div>
	);
};

export default DENTModalOverviewPeriodontalSelectMapBox;
